/**
 * 순위 계산 유틸리티
 * 공동 순위 계산을 위한 공통 함수
 */

/**
 * 공동 순위 계산 함수 (최적화된 버전)
 * @param sortedList 정렬된 배열 (점수 높은 순)
 * @param index 현재 인덱스
 * @returns 순위 (1부터 시작)
 */
export const calculateRank = <T extends { score: number }>(sortedList: T[], index: number): number => {
  if (index === 0) return 1;
  
  // 이전 인덱스와 점수가 다르면 현재 인덱스 + 1이 순위
  if (sortedList[index].score !== sortedList[index - 1].score) {
    return index + 1;
  }
  
  // 점수가 같으면 이전 플레이어와 같은 순위
  return calculateRank(sortedList, index - 1);
};

/**
 * 전체 순위 배열을 한 번에 계산하는 최적화된 함수
 * @param sortedList 정렬된 배열 (점수 높은 순)
 * @returns 순위 배열
 */
export const calculateAllRanks = <T extends { score: number }>(sortedList: T[]): number[] => {
  if (sortedList.length === 0) return [];
  
  const ranks = new Array(sortedList.length);
  ranks[0] = 1;
  
  for (let i = 1; i < sortedList.length; i++) {
    if (sortedList[i].score === sortedList[i - 1].score) {
      ranks[i] = ranks[i - 1]; // 같은 점수면 같은 순위
    } else {
      ranks[i] = i + 1; // 다른 점수면 현재 인덱스 + 1
    }
  }
  
  return ranks;
};

